module.exports = __webpack_public_path__ + "static/media/EOS.a84fdd8e.svg";